import { checkToken } from './api'

export const checkEmailValidationToken = token => dispatch => checkToken(token)